export default "__VITE_ASSET__CMAmzcla__"